export class VacationDaysDatKey {
  recordId: number;
  date: string;

  constructor(props: VacationDaysDatKey) {
    this.recordId = props.recordId;
    this.date = props.date;
  }
}
